module.exports = __webpack_public_path__ + "static/media/signature.753915e7.png";